import React from "react"
import styled from "styled-components"
import { Button, Paragraph } from "buoy-core"
import { responsive, fontSize } from "buoy-theme"
import { SVG_URL } from "../../common/constants"

const ReEntryText = styled(Paragraph)`
  ${fontSize("bodySmall")};
  margin: 0;
`

const ReEntryContainer = styled.div`
  display: flex;
  ${responsive("flex-direction", "column", "column", "column", "column", "row")};
  justify-content: space-between;
  ${responsive("align-items", "flex-end", "flex-end", "flex-end", "flex-end", "center")};
  ${responsive("margin-top", "0", "0", "0", "0", "12px")};
`

const Icon = styled.img.attrs({
  src: `${SVG_URL}cirrus/live_icon.svg`,
})`
  margin-top: 2px;
  margin-right: 4px;
`

const TextRow = styled.div`
  display: flex;
  align-items: center;
  ${responsive("margin-bottom", "12px", "12px", "12px", "12px", "0")};
`

const ReEntry = ({ recent, onClick }) => (
  <ReEntryContainer>
    <TextRow>
      <Icon />
      <ReEntryText color="neutralDark">You chatted with a doctor</ReEntryText>
    </TextRow>
    <Button onClick={onClick} color={recent ? "primary" : "landingBlue"}>
      {recent ? "Continue Chat" : "View Record"}
    </Button>
  </ReEntryContainer>
)

export { ReEntry as default }



// WEBPACK FOOTER //
// ./assets/account/components/ReEntry.js